import { SiteMeta } from '@src/types/SiteMeta';
import storeConnector from '@store/storeConnector';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  styled,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { CommandsCategory } from '@src/types/Commands';
import { CommandsModalContextProvider } from '../CommandsModalContext';
import BreakerSection from './BreakerSection';
import EnableDisableSection from './EnableDisableSection';

const StyledDialogTitle = styled(DialogTitle)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

interface Props {
  tscName: string;
  open: boolean;
  mpId: string;
  mpName: string;
  onClose: () => void;
  siteMeta: SiteMeta;
}

function MPCommandsModal({
  tscName,
  open,
  mpId,
  mpName,
  onClose,
  siteMeta,
}: Props) {
  return (
    <CommandsModalContextProvider
      category={CommandsCategory.MP}
      deviceId={siteMeta.siteId}
      defaultParams={{
        MP: mpId.split('_').pop(),
      }}
    >
      <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
        <StyledDialogTitle>
          {tscName} {mpName} Controls
          <IconButton onClick={onClose} sx={{ mr: -2, mt: -1 }}>
            <CloseIcon />
          </IconButton>
        </StyledDialogTitle>
        <DialogContent dividers>
          <Box sx={{ mt: 1 }}>
            <BreakerSection />
          </Box>
          <Box sx={{ mt: 3 }}>
            <EnableDisableSection />
          </Box>
        </DialogContent>
      </Dialog>
    </CommandsModalContextProvider>
  );
}

export default storeConnector(MPCommandsModal, {
  config: ['siteMeta'],
});
